"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = require("styled-components");
var Icon = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n\n  position: relative;\n"], ["\n  ",
    "\n\n  position: relative;\n"])), function (props) { return "\n      width: " + props.size + "em;\n      height: " + props.size + "em;\n    "; });
exports.default = { Icon: Icon };
var templateObject_1;
//# sourceMappingURL=SearchIcon.style.js.map